import React from 'react';

import * as Icon from 'react-feather';

// Roles: "Admin", "Manager", "Cashier"
// Each top-level section and sub-item can have a `roles` array.
// If `roles` is not present, it is visible to ALL roles.

export const SidebarData = [
          
    {
        label: "Main",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Main",
        roles: ["Admin", "Manager"],
        submenuItems: [
        {
            label: "Dashboard",
            icon: <Icon.Grid  />,
            submenu: false,
            showSubRoute: false,
            link: "/",
            roles: ["Admin", "Manager"]
          }
        ]
      },
      {
        label: "Restaurant POS",
        submenuOpen: true,
        submenuHdr: "Restaurant POS",
        submenu: false,
        showSubRoute: false,
        roles: ["Admin", "Manager", "Cashier"],
        submenuItems: [
          { label: "POS Terminal", link: "/pos", icon: <Icon.HardDrive />,showSubRoute: false,submenu: false, roles: ["Admin", "Manager", "Cashier"] },
          { label: "Active Orders", link: "/restaurant/orders", icon: <Icon.ShoppingCart />,showSubRoute: false,submenu: false, roles: ["Admin", "Manager", "Cashier"] },
        ]
      },
      {
        label: "Menu Management",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Menu Management",
        roles: ["Admin", "Manager"],
        submenuItems: [
          { label: "Menu Items", link: "/restaurant/menu-items", icon:<Icon.Box />,showSubRoute: false,submenu: false, roles: ["Admin", "Manager"] },
          { label: "Categories", link: "/category-list", icon:  <Icon.Codepen />,showSubRoute: false,submenu: false, roles: ["Admin", "Manager"] },
        ]
      },
      {
        label: "Inventory",
        submenuOpen: true,
        submenuHdr: "Inventory",
        submenu: true,
        showSubRoute: false,
        roles: ["Admin", "Manager", "Cashier"],
        submenuItems: [
          { label: "Inventory Items", link: "/inventory-items", icon: <Icon.Package />, showSubRoute: false, submenu: false, roles: ["Admin", "Manager"] },
          { label: "Stock Management", link: "/stock-management", icon: <Icon.Archive />, showSubRoute: false, submenu: false, roles: ["Admin", "Manager", "Cashier"] },
          { label: "Weekly Closing", link: "/weekly-closing", icon: <Icon.Calendar />, showSubRoute: false, submenu: false, roles: ["Admin", "Manager", "Cashier"] },
          { label: "Transactions Ledger", link: "/inventory-ledger", icon: <Icon.List />, showSubRoute: false, submenu: false, roles: ["Admin", "Manager"] },
          { label: "Finance Analytics", link: "/finance-analytics", icon: <Icon.PieChart />, showSubRoute: false, submenu: false, roles: ["Admin", "Manager"] },
        ]
      },
      {
        label: "Promo",
        submenuOpen: true,
        submenuHdr: "Promo",
        showSubRoute: false,
        roles: ["Admin", "Manager"],
        submenuItems: [
          { label: "Coupons", link: "/coupons", icon:  <Icon.ShoppingCart />,showSubRoute: false, submenu: false, roles: ["Admin", "Manager"] }
        ]
      },
      {
        label: "Purchases",
        submenuOpen: true,
        submenuHdr: "Purchases",
        showSubRoute: false,
        roles: ["Admin"],
        submenuItems: [
          { label: "Purchases", link: "/purchase-list", icon:  <Icon.ShoppingBag />,showSubRoute: false,submenu: false, roles: ["Admin"] },
          { label: "Purchase Order", link: "/purchase-order-report", icon:  <Icon.FileMinus />,showSubRoute: false ,submenu: false, roles: ["Admin"]},
          { label: "Purchase Return", link: "/purchase-returns", icon:  <Icon.RefreshCw />,showSubRoute: false,submenu: false, roles: ["Admin"] }
        ]
      },
    
    

    {
        label: "Finance & Accounts",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Finance & Accounts",
        roles: ["Admin"],
        submenuItems: [
          {
            label: "Expenses",
            submenu: true,
            showSubRoute: false,
            icon: <Icon.FileText />,
            roles: ["Admin"],
            submenuItems: [
              {label: "Expenses", link: "/expense-list",showSubRoute: false, roles: ["Admin"]},
              {label: "Expense Category", link: "/expense-category",showSubRoute: false, roles: ["Admin"]}
            ]
          }
        ]
      },

      {
        label: "Reports",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Reports",
        roles: ["Admin"],
        submenuItems: [
          { label: "Sales Report", link: "/sales-report", icon:  <Icon.BarChart2 /> ,showSubRoute: false, roles: ["Admin"]},
          { label: "Purchase Report", link: "/purchase-report", icon:  <Icon.PieChart />,showSubRoute: false, roles: ["Admin"] },
          { label: "Inventory Report", link: "/inventory-report", icon:  <Icon.Inbox />,showSubRoute: false, roles: ["Admin"] },
          { label: "Invoice Report", link: "/invoice-report", icon:  <Icon.File />,showSubRoute: false, roles: ["Admin"] },
          { label: "Supplier Report", link: "/supplier-report", icon:  <Icon.UserCheck />,showSubRoute: false, roles: ["Admin"] },
          { label: "Customer Report", link: "/customer-report", icon:  <Icon.User />,showSubRoute: false, roles: ["Admin"] },
          { label: "Expense Report", link: "/expense-report", icon:  <Icon.FileText />,showSubRoute: false, roles: ["Admin"] },
          { label: "Income Report", link: "/income-report", icon:  <Icon.BarChart />,showSubRoute: false, roles: ["Admin"] },
          { label: "Tax Report", link: "/tax-report", icon:  <Icon.Database />,showSubRoute: false, roles: ["Admin"] },
          { label: "Profit & Loss", link: "/profit-loss-report", icon:  <Icon.TrendingDown />,showSubRoute: false, roles: ["Admin"] }
        ],
      },


      {
        label: "User Management",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "User Management",
        roles: ["Admin"],
        submenuItems: [
          { label: "Users", link: "/users", icon:  <Icon.UserCheck />,showSubRoute: false, roles: ["Admin"] },
          { label: "Roles & Permissions", link: "/roles-permissions", icon:  <Icon.UserCheck />,showSubRoute: false, roles: ["Admin"] },
          { label: "Delete Account Request", link: "/delete-account", icon:  <Icon.Lock />,showSubRoute: false, roles: ["Admin"] }
        ]
      },

      {
        label: "Settings",
        submenu: true,
        showSubRoute: false,
        submenuHdr: "Settings",
        roles: ["Admin", "Manager", "Cashier"],
        submenuItems: [
          { 
            label: "My Profile", 
            link: "/profile", 
            icon: <Icon.User />,
            showSubRoute: false, 
            roles: ["Admin", "Manager", "Cashier"] 
          },
          { label: "General Settings", 
          submenu: true, 
          showSubRoute: false,
          icon: <Icon.Settings/>,
          roles: ["Admin"],
          submenuItems: [
            { label: "Profile", link: "/general-settings", roles: ["Admin"] },
            { label: "Security", link: "/security-settings", roles: ["Admin"] },
            { label: "Notifications", link: "/notification", roles: ["Admin"] },
            { label: "Connected Apps", link: "/connected-apps", roles: ["Admin"] }
          ]},
          { label: "Website Settings", submenu: true, 
          showSubRoute: false,
          icon: <Icon.Globe/>,
          roles: ["Admin"],
          submenuItems: [
            { label: "System Settings", link: "/system-settings",showSubRoute: false },
            { label: "Company Settings", link: "/company-settings",showSubRoute: false },
            { label: "Localization", link: "/localization-settings",showSubRoute: false },
            { label: "Prefixes", link: "/prefixes" ,showSubRoute: false},
            { label: "Preference", link: "/preference",showSubRoute: false },
            { label: "Appearance", link: "/appearance",showSubRoute: false },
            { label: "Social Authentication", link: "/social-authentication",showSubRoute: false },
            { label: "Language", link: "/language-settings" ,showSubRoute: false}
          ]},
          { label: "App Settings", submenu: true, 

          showSubRoute: false,
          icon: <Icon.Smartphone/>,
          roles: ["Admin"],
        submenuItems: [
            { label: "Invoice", link: "/invoice-settings",showSubRoute: false },
            { label: "Printer", link: "/printer-settings",showSubRoute: false },
            { label: "POS", link: "/pos-settings",showSubRoute: false },
            { label: "Custom Fields", link: "/custom-fields",showSubRoute: false }
          ]},
          { label: "System Settings", submenu: true, 
          showSubRoute: false,
          icon: <Icon.Monitor/>,
          roles: ["Admin"],
          submenuItems: [
            { label: "Email", link: "/email-settings",showSubRoute: false },
            { label: "SMS Gateways", link: "/sms-gateway",showSubRoute: false },
            { label: "OTP", link: "/otp-settings",showSubRoute: false },
            { label: "GDPR Cookies", link: "/gdpr-settings",showSubRoute: false }
          ]},
          { label: "Financial Settings", submenu: true, 
          showSubRoute: false,
          icon: <Icon.DollarSign/>,
          roles: ["Admin"],
          submenuItems: [
            { label: "Payment Gateway", link: "/payment-gateway-settings",showSubRoute: false },
            { label: "Bank Accounts", link: "/bank-settings-grid",showSubRoute: false },
            { label: "Tax Rates", link: "/tax-rates",showSubRoute: false },
            { label: "Currencies", link: "/currency-settings",showSubRoute: false }
          ]},
          { label: "Other Settings", submenu: true, 
          showSubRoute: false,
          icon: <Icon.Hexagon/>,
          roles: ["Admin"],
          submenuItems: [
            { label: "Storage", link: "/storage-settings",showSubRoute: false },
            { label: "Ban IP Address", link: "/ban-ip-address",showSubRoute: false }
          ]},
          { label: "Logout", link: "/signin", icon:  <Icon.LogOut />,showSubRoute: false, roles: ["Admin", "Manager", "Cashier"] }
        ]
      }
      

]
